import { useQuery } from '@tanstack/react-query';

import { useIsLoggedIn } from '@hcs/authn';

import { HuellApi } from '../api';

export const QUERY_KEY_UI_PREFERENCES_USER = 'uiPreferences-user';
export const useUiPreferencesForUser = () => {
  const {
    data: { isLoggedIn },
  } = useIsLoggedIn();
  return useQuery({
    queryKey: [QUERY_KEY_UI_PREFERENCES_USER],
    queryFn: HuellApi.fetchUiPreferencesForUser,
    enabled: isLoggedIn,
  });
};
